import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import useReveal from "@/hooks/useReveal";
import { faq } from "@/lib/home-content";

export default function FAQ() {
    const { ref, visible } = useReveal();
    return (
        <section id="faq" className="bg-white px-5 py-16 sm:py-20">
            <div ref={ref} className={`reveal mx-auto max-w-3xl ${visible ? "is-visible" : ""}`}>
                <div className="mb-8 text-center">
                    <span className="rounded-full bg-[var(--brand-soft)] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[var(--brand)]">
                        {faq.kicker}
                    </span>
                    <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-[#0a0a0b] sm:text-4xl">
                        {faq.title}
                    </h2>
                </div>
                <Accordion type="single" collapsible className="space-y-3">
                    {faq.items.map((item, i) => (
                        <AccordionItem
                            key={item.q}
                            value={`item-${i}`}
                            className="overflow-hidden rounded-2xl border-0 bg-[#f6f7fb] px-5 ring-1 ring-black/5"
                        >
                            <AccordionTrigger className="py-5 text-left font-display text-base font-bold text-[#0a0a0b] hover:no-underline sm:text-lg">
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="pb-5 text-sm leading-relaxed text-[#5b5b66]">
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
